import React from "react";
import LocationEditorialSection from "./LocationEditorialSection";
import GoldValueFactorsSection from "./GoldValueFactorsSection";
import LocationReasonsTimeline from "./LocationReasonsTimeline";
import BeforeSellingPointsSection from "./BeforeSellingPointsSection";
import ImageContentFeatureSection from "./ImageContentFeatureSection";
import LocationFinalCTASection from "./LocationFinalCTASection";
export default function RajajinagarContentSections() {
  const explainValueParagraphs = [
    "When choosing gold buyers in Rajajinagar, the highest verbal offer is not always the most important thing. What matters is whether the buyer explains how the price is calculated and what deductions are made.",
    "G1 Gold follows a step-by-step checking process. The purity, weight, gold rate, and non-gold parts are explained before the final value is confirmed. This is especially helpful for first-time sellers, customers selling family jewellery, or anyone comparing gold buyers before making a decision.",
    "Instead of selling in confusion, you can understand the value of your gold item by item and proceed only when you are comfortable with the amount.",
  ];

  const cashParagraphs = [
    "If you want to sell gold for cash in Rajajinagar, G1 Gold keeps the process simple and clear. You can bring your gold items, get them checked, review the valuation, ask questions, and proceed only if you are comfortable with the final amount.",
    "This service is helpful for customers who need quick cash support but do not want to sell gold without knowing the proper calculation. The final price is shared only after checking the gold properly, so you know how the amount is decided before confirming the sale.",
  ];

  const valueFactors = [
    {
      title: "Purity of the Gold",
      text: "The purity level decides how much real gold is present in the ornament. Higher purity usually gives better value.",
    },
    {
      title: "Usable Gold Weight",
      text: "Only the actual gold weight is considered for valuation. Stones, beads, and other non-gold parts are not included in the payable gold weight.",
    },
    {
      title: "Current Gold Rate",
      text: "Gold prices keep changing, so the value is calculated based on the current gold rate used at the time of valuation.",
    },
    {
      title: "Item Condition",
      text: "Broken, dull, or outdated jewellery can still be sold. The condition of the design matters less than the actual gold content.",
    },
  ];

  const customerReasons = [
    {
      title: "Item-Wise Gold Checking",
      text: "Each ornament can be checked separately, helping customers understand the value of every item.",
    },
    {
      title: "No Forced Selling",
      text: "You can review the offer first and continue only if you are comfortable with the amount.",
    },
    {
      title: "Clear Gold Rate Calculation",
      text: "The price is connected to the current gold rate, not a random or unclear value.",
    },
    {
      title: "Useful for Urgent Needs",
      text: "Old or unused gold can help manage sudden financial needs without complicated steps.",
    },
    {
      title: "Comfortable for First-Time Sellers",
      text: "Customers who are selling gold for the first time can understand the process before making a decision.",
    },
    {
      title: "Quick Payment Support",
      text: "After valuation and customer approval, payment is completed quickly and safely.",
    },
  ];
const beforeSellingPoints = [
  {
    check: "Purity Testing",
    reason: "Helps identify the real gold quality.",
  },
  {
    check: "Net Gold Weight",
    reason: "Ensures only actual gold weight is valued.",
  },
  {
    check: "Current Gold Rate",
    reason: "Helps calculate the latest market-linked value.",
  },
  {
    check: "Stone or Bead Deduction",
    reason: "Prevents confusion in jewellery valuation.",
  },
  {
    check: "Final Amount Explanation",
    reason: "Helps you understand the complete offer.",
  },
  {
    check: "Payment Process",
    reason: "Ensures safe and quick transaction completion.",
  },
];
  return (
    <>
      <LocationEditorialSection
  title="Gold Buyers in Rajajinagar Who Explain the Value Clearly"
  paragraphs={explainValueParagraphs}
  background="bg-[#fffaf0]"
  image="/images/branches/gold-buyers-rajajinagar.webp"
  imageAlt="Gold buyers in Rajajinagar"
/>
<LocationEditorialSection
  title="Sell Gold for Cash in Rajajinagar Without Confusion"
  paragraphs={cashParagraphs}
  background="bg-white"
  reverse
  image="/images/branches/sell-gold-cash-rajajinagar.webp"
  imageAlt="Sell gold for cash in Rajajinagar"
/>

      <GoldValueFactorsSection
        title="What Makes Your Gold Valuable?"
        description="Gold value is not decided by design, age, or appearance alone. Even old or damaged jewellery can have good value if the gold purity and weight are strong."
        items={valueFactors}
      />

      <LocationReasonsTimeline
        title="Why Customers Choose G1 Gold in Rajajinagar"
        items={customerReasons}
      />
      <BeforeSellingPointsSection
  title="Before Selling Gold in Rajajinagar Check These Points"
  description="Before selling your gold, make sure you understand these details"
  points={beforeSellingPoints}
  closingText="G1 Gold follows a clear process so customers can review the value before confirming the sale."
/>
<ImageContentFeatureSection
  title="Best Option for Old and Unused Gold"
  paragraphs={[
    "Many people keep jewellery at home for years without using it. Some ornaments may be broken, outdated, mismatched, or no longer useful. Instead of keeping idle gold unused, you can check its current value and decide whether selling is the right option.",
    "G1 Gold helps Rajajinagar customers understand the worth of their gold without pressure. You can check the value first, ask questions, compare the offer, and sell only after you are satisfied.",
  ]}
  image="/images/branches/jayanagar-main.webp"
  imageAlt="Old and unused gold valuation in Rajajinagar"
/>
<LocationFinalCTASection
  title="Sell Gold in Rajajinagar Today"
  description="Want to sell gold in Rajajinagar today? Visit G1 Gold for clear gold testing, transparent valuation, live gold rate based pricing, and quick payment after approval."
  phone="+91 7996 800 900"
  whatsappNumber="917996800900"
/>
    </>
  );
}